import request from '../request';
const baseUrl = process.env.NODE_ENV !== 'production'
    ? 'common' // 开发环境
    : 'common'; // 生产环境
export function getLoginIdentifyCode(params) {
    return request.post(baseUrl + '/captcha/login', params);
}
export function getregisterIdentifyCode(params) {
    return request.post(baseUrl + '/captcha/register', params);
}
// 获取邮箱验证码【注册】
export function getVerificationEmailRegister(params) {
    return request.post(baseUrl + '/verification/email/register', params);
}
// 国家备选
export function getCountrySpareList(params) {
    return request.post(baseUrl + '/countries/list', params);
}
// 地址搜索
export function searchAddress(param) {
    return request.post(`${baseUrl}/address/search`, param);
}
// 用户称谓
export function getUserTitle() {
    return request.post(`${baseUrl}/user/titles`);
}
// 获取 港口及泊位数描述 选项
export function getPortBerthOptionsApi() {
    return request.post(`${baseUrl}/port-berth/options`);
}
// 日志】删除人
export function getDeleterInfoApi(type, id, eid) {
    return request.post(`${baseUrl}/deleter/info`, { type, id, eid });
}
// 【权限】获取权限映射关系
export function getJobPermissionMapApi() {
    return request.post(baseUrl + '/job/permission/map');
}
// 公告分页数据
export function getAnnouncementListApi(page) {
    return request.post(baseUrl + '/announcement/list', { page });
}
// 用户手册分页数据
export function getGuidanceListApi(page) {
    return request.post(baseUrl + '/guidance/list', { page });
}
// 【手册】获取所有用户手册/指南
export function getGuidanceAllApi(page) {
    return request.post(baseUrl + '/guidance/all', { page });
}
// 获取平台简介信息
export function getAboutUsApi() {
    return request.post(baseUrl + '/about-us');
}
// 获取所有海运DWT规则
export function getMarineBallastRulesAllApi() {
    return request.post(baseUrl + '/marine/ballast-rules/all');
}
// 获取交流痕迹模板
export function getNoteTemplatesApi() {
    return request.post(baseUrl + '/note/templates');
}
export default { getLoginIdentifyCode, getregisterIdentifyCode, getVerificationEmailRegister, searchAddress, getUserTitle };
